import React from 'react'
import { truncate } from 'lib/utils'

import ReviewRating from '../ReviewRating/ReviewRating'
import { VideoCardProfileReviewProps } from '../type'

import styles from './VideoCardProfileReview.module.css'

const VideoCardProfileReview: React.FC<VideoCardProfileReviewProps> = ({
  review,
  expanded,
}) => {
  const { rating, messageToProfile } = review

  return (
    <div className={styles.card}>
      {rating && (
        <div className={styles.reviewMeta}>
          <ReviewRating
            rating={review.rating}
            showReviewText={false}
            renderModalLink={false}
          />
        </div>
      )}

      {messageToProfile && (
        <p className={styles.text}>
          &quot;
          {expanded ? messageToProfile : truncate(messageToProfile, 53)}
          &quot;
        </p>
      )}
    </div>
  )
}

export default VideoCardProfileReview
